export const api_url = "https://spontasyapi.sportsseam.com/";

export const token =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX25hbWUiOiJyYXppbiIsImV4cCI6MTYxNjI1MDM1NX0.w6CFkV83OvK03bSg4dKKyct9XI-wK-J0ZSldGmklrFs";
export const s3BaseURL =
   "https://data-spontasy-24.s3.ap-south-1.amazonaws.com/web/";


export const platform_logo_path_map = {
  dream11: `${s3BaseURL}res/jpg/dream11logo.png`,
};

export const default_player_image_url = "https://data-spontasy-24.s3.ap-south-1.amazonaws.com/IPL23/default-headshot.png"

export const game_logo_path_map = {
  CWC: `${s3BaseURL}res/jpg/cwc.png`,
  WBBL: `${s3BaseURL}res/jpg/wbbl.png`,
  IPL: `${s3BaseURL}res/jpg/ipl2021Temp_64.png`,
  PSL: `${s3BaseURL}res/jpg/psl_logo64.png`,
  VB: `${s3BaseURL}res/jpg/vbLogo64.png`,
  CPL: `${s3BaseURL}res/jpg/cpl-logo.png`,
  WC: `${s3BaseURL}res/jpg/wct20_icon64p.png`,
  BBL: `${s3BaseURL}res/jpg/BBL64p.png`,
  WPL: `${s3BaseURL}res/jpg/wpl.png`,
  MLC: `${s3BaseURL}res/jpg/MLC.png`,
  LPL: `${s3BaseURL}res/jpg/lpl.png`,
  ASIACUP: `${s3BaseURL}res/jpg/asiacup.png`,
  INDVAUS: `${s3BaseURL}res/jpg/indvaus.png`,
  INDVAUST20: `${s3BaseURL}res/jpg/indvaus.png`,
  ABUDHABIT10: `${s3BaseURL}res/jpg/abudhabit10.png`,
  LLC: `${s3BaseURL}res/jpg/llc.png`,
  INDVSAT20: `${s3BaseURL}res/jpg/indvsat20.png`,
  ENGVWIT20: `${s3BaseURL}res/jpg/engvwit20.png`,
  "SUPER-SMASH-MEN": `${s3BaseURL}res/jpg/supersmash.png`,
  "SUPER-SMASH-WOMEN": `${s3BaseURL}res/jpg/supersmash.png`,
  "NZVPAK-T20": `${s3BaseURL}res/jpg/nzvpak.png`,
  "INDVAFG-T20": `${s3BaseURL}res/jpg/indvafg.png`,
  SA20: `${s3BaseURL}res/jpg/SA20.png`,
  PKL: `${s3BaseURL}res/jpg/pkl.png`,
  ILT20: `${s3BaseURL}res/jpg/ilt20.png`,
  BPL: `${s3BaseURL}res/jpg/bpl.png`,
  NBA: `${s3BaseURL}res/jpg/nba.png`,
  WCT20: `${s3BaseURL}res/jpg/wct20_icon64p.png`,
  "ENGVNZ-WODI": `${s3BaseURL}res/jpg/engvnz.png`,
  'ZIMVIND-T20': `${s3BaseURL}res/jpg/zimvind.png`,
  'WASIACUP': `${s3BaseURL}res/jpg/asiacup.png`,
  'HUNDRED': `${s3BaseURL}res/jpg/hundred.png`,
  'WHUNDRED': `${s3BaseURL}res/jpg/hundred.png`,
  'SLVIND-T20': `${s3BaseURL}res/jpg/slvind.png`,
  'SLVIND-ODI': `${s3BaseURL}res/jpg/slvind.png`,
  'WCPL': `${s3BaseURL}res/jpg/wcpl.png`,
  'WIVSA-T20': `${s3BaseURL}res/jpg/wivsa.png`,
  'AUSVSCOT': `${s3BaseURL}res/jpg/ausvscot.png`,
  'ENGVIRE-WODI': `${s3BaseURL}res/jpg/engvire.png`,
  'AUSVENG-T20': `${s3BaseURL}res/jpg/ausveng.png`,
  'PAKVSA-WT20': `${s3BaseURL}res/jpg/pakvsa.png`,
  'AFGVSA-ODI': `${s3BaseURL}res/jpg/afgvsa.png`,
  'CWC-L2-ODI': `${s3BaseURL}res/jpg/cwcl2.png`,
  'AUSVNZ-WT20': `${s3BaseURL}res/jpg/ausvnz.png`,
  'AUSVENG-ODI': `${s3BaseURL}res/jpg/ausveng.png`,
  'CSA-T20': `${s3BaseURL}res/jpg/csa_t20.png`,
  'WWC-T20': `${s3BaseURL}res/jpg/wwc.png`,
  'INDVNZ-WODI': `${s3BaseURL}res/jpg/indvnz.png`,
  'INDVBAN-T20': `${s3BaseURL}res/jpg/indvban.png`,
  'WBBL': `${s3BaseURL}res/jpg/wbbl.png`,
  'AUSVPAK-T20': `${s3BaseURL}res/jpg/ausvpak.png`,
  'SLVNZ-ODI': `${s3BaseURL}res/jpg/slvnz.png`,
  'PAKVZIM-T20': `${s3BaseURL}res/jpg/pakvzim.png`,
  'SAVENG-WODI': `${s3BaseURL}res/jpg/saveng.png`,
  'INDVAUS-WODI': `${s3BaseURL}res/jpg/indvaus.png`,
  'INDVWI-WODI': `${s3BaseURL}res/jpg/indvwi.png`,
  'NZVSL-T20': `${s3BaseURL}res/jpg/nzvsl.png`,
  'SUPER-SMASH-MEN': `${s3BaseURL}res/jpg/supersmash.png`,
  'CHAMPIONS-TROPHY': `${s3BaseURL}res/jpg/championsTrophy.png`,
};

export const feedbackEmail = "spontasy@sportsseam.com";
export const contactUsEmail = "spontasy@sportsseam.com";

export const spordiaPrivacyLink =
  "https://data-spontasy-24.s3.ap-south-1.amazonaws.com/docs/spordia_privacy.pdf";
export const spordiaTermsLink =
  "https://data-spontasy-24.s3.ap-south-1.amazonaws.com/docs/spordia_terms.pdf";
export const faqLink =
  "https://data-spontasy-24.s3.ap-south-1.amazonaws.com/docs/faq.pdf";

export const spordiaWebsiteLink = "https://www.sportsseam.com/";

// export const season = new Date().getFullYear().toString();
export const season = 2024;
export const API_CONSTANTS = {
  NUMERIC_CONSTANT: -999,
  NULL_CONSTANT: null,
  EMPTY_STRING: "",
};
export const version = "1.10.21";
// something

export const PLAYER_STATUSES = [
  "Announced",
  "Substitute",
  "Played last match",
  "Played last match(sub_in)",
  "Played last match(sub_out)",
];

export const RECOMMENDATION_OPTIMIZERS = ["R1", "R2", "R3"];

export const DEFAULT_OPTIMIZER = "PFP";

export const BLOG_EMAIL = "spontasy@sportsseam.com";

export const firestoreCollections = [
  "lineups",
  "excludedPlayers",
  "lockedPlayers",
];

export const TOSS_EVENT = {
  NOT_HAPPENED: 0,
  HAPPENED: 1,
};

export const INJURY_STATUS = {
  PROBABLE: "Probable",
  QUESTIONABLE: "Questionable",
  OUT: "Out",
};

export const OPERATOR_STATUS = {
  ANNOUNCED: "Announced",
  ANNOUNCED_SUB: "Announced (X-Sub)",
  SUBSTITUTE: "Substitute",
  UNANNOUNCED: "Unannounced",
  PLAYED_LAST_MATCH: "Played last match",
  PLAYED_LAST_MATCH_SUB_IN: "Played last match(sub_in)",
  PLAYED_LAST_MATCH_SUB_OUT: "Played last match(sub_out)",
  NULL_CONSTANT: "NULL_CONSTANT", // Assuming this is the value for comparison
};
